import { Link, type LinkProps } from "@octopus-energy/coral/atoms"
import { formatPhone } from "@/utils/formatPhone"

type PhoneLinkProps = Omit<LinkProps, "children" | "href"> & {
    phone: string
}

export function PhoneLink({ phone, ...linkProps }: PhoneLinkProps) {
    return (
        <Link
            href={`tel:${phone}`}
            {...linkProps}
        >
            {formatPhone(phone)}
        </Link>
    )
}
